import './App.css';

import React, { useState } from 'react';
import NavBar from './components/NavBar';
import News from './components/News';
import Home from './components/Home'; // FIX THIS PATH
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import LoadingBar from 'react-top-loading-bar';

const App = () => {

    const pageSize = 5;
    const apiKey = "pub_590a294a9e544a5984a2ecdc09ba1742";

    const [progress, setProgress] = useState(0);

    return (
        <div>

            <Router>

                <NavBar />

                <LoadingBar
                    height={3}
                    color='#f11946'
                    progress={progress}
                />

                <Switch>

                    <Route exact path="/">
                        <Home />
                    </Route>

                    <Route exact path="/business">
                        <News setProgress={setProgress} apiKey={apiKey} key="business" pageSize={pageSize} country="in" category="business" />
                    </Route>

                    <Route exact path="/entertainment">
                        <News setProgress={setProgress} apiKey={apiKey} key="entertainment" pageSize={pageSize} country="in" category="entertainment" />
                    </Route>

                    <Route exact path="/health">
                        <News setProgress={setProgress} apiKey={apiKey} key="health" pageSize={pageSize} country="in" category="health" />
                    </Route>

                    <Route exact path="/science">
                        <News setProgress={setProgress} apiKey={apiKey} key="science" pageSize={pageSize} country="in" category="science" />
                    </Route>

                    <Route exact path="/sports">
                        <News setProgress={setProgress} apiKey={apiKey} key="sports" pageSize={pageSize} country="in" category="sports" />
                    </Route>

                    <Route exact path="/technology">
                        <News setProgress={setProgress} apiKey={apiKey} key="technology" pageSize={pageSize} country="in" category="technology" />
                    </Route>

                </Switch>

            </Router>

        </div>
    );
};

export default App;
